// File: src/pages/candidate/CVReviewResultPage.jsx
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export default function CVReviewResultPage() {
    const location = useLocation();
    const navigate = useNavigate();
    const result = location.state?.result;

    if (!result) {
        return (
            <div style={{ 
                minHeight: '100vh', 
                display: 'flex', 
                flexDirection: 'column', 
                alignItems: 'center', 
                justifyContent: 'center', 
                backgroundColor: '#F3F4F6' 
            }}>
                <h2 style={{ color: '#374151', marginBottom: 16 }}>Chưa có dữ liệu phân tích</h2>
                <button 
                    onClick={() => navigate('/')}
                    style={{
                        padding: '10px 20px',
                        backgroundColor: '#2563EB',
                        color: 'white',
                        border: 'none',
                        borderRadius: '8px',
                        fontWeight: '600',
                        cursor: 'pointer'
                    }}
                >
                    Về trang chủ upload lại
                </button>
            </div>
        );
    }

    return (
        // ✅ FIX LỖI ĐEN XÌ: Thêm backgroundColor và minHeight cho thẻ bao ngoài cùng
        <div style={{ 
            backgroundColor: '#F3F4F6', // Màu nền xám sáng (giống trang Test Result)
            minHeight: '100vh',         // Chiều cao full màn hình
            padding: '100px 20px 150px', // Padding để tránh dính Header/Footer
            fontFamily: 'sans-serif'
        }}>
            
            {/* Container căn giữa nội dung */}
            <div style={{ maxWidth: '900px', margin: '0 auto' }}>
                
                <button 
                    onClick={() => navigate('/')} 
                    style={{ 
                        marginBottom: 20, 
                        cursor: 'pointer', 
                        border: 'none', 
                        background: 'none', 
                        color: '#4B5563',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        fontWeight: '500'
                    }}
                >
                    <span className="material-symbols-outlined" style={{ fontSize: '20px' }}>arrow_back</span> 
                    Quay lại trang chủ
                </button>
                
                <div style={{ background: 'white', borderRadius: 24, padding: 40, boxShadow: '0 4px 20px rgba(0,0,0,0.05)' }}>
                    {/* Header Điểm số */}
                    <div style={{ textAlign: 'center', marginBottom: 40 }}>
                        <div style={{ 
                            width: 120, height: 120, borderRadius: '50%', background: '#EFF6FF', 
                            color: '#2563EB', display: 'flex', flexDirection: 'column', 
                            alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px', 
                            border: '6px solid #BFDBFE', fontSize: 40, fontWeight: 800 
                        }}>
                            {result.score}
                        </div>
                        <h1 style={{ margin: 0, fontSize: 24, color: '#111827' }}>Đánh giá CV của bạn</h1>
                        <p style={{ color: '#6B7280', marginTop: 12, lineHeight: 1.6, maxWidth: '600px', margin: '12px auto 0' }}>
                            {result.summary}
                        </p>
                    </div>

                    {/* Grid Điểm mạnh / Yếu */}
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: 30, marginBottom: 40 }}>
                        <div style={{ background: '#ECFDF5', padding: 24, borderRadius: 16, border: '1px solid #D1FAE5' }}>
                            <h3 style={{ color: '#059669', margin: '0 0 16px', display: 'flex', alignItems: 'center', gap: 8, fontSize: '18px' }}>
                                ✅ Điểm mạnh
                            </h3>
                            <ul style={{ paddingLeft: 20, margin: 0, color: '#065F46', lineHeight: 1.6 }}>
                                {result.strengths?.map((s, i) => <li key={i} style={{ marginBottom: 8 }}>{s}</li>)}
                            </ul>
                        </div>
                        <div style={{ background: '#FEF2F2', padding: 24, borderRadius: 16, border: '1px solid #FEE2E2' }}>
                            <h3 style={{ color: '#DC2626', margin: '0 0 16px', display: 'flex', alignItems: 'center', gap: 8, fontSize: '18px' }}>
                                ⚠️ Cần cải thiện
                            </h3>
                            <ul style={{ paddingLeft: 20, margin: 0, color: '#991B1B', lineHeight: 1.6 }}>
                                {result.weaknesses?.map((s, i) => <li key={i} style={{ marginBottom: 8 }}>{s}</li>)}
                            </ul>
                        </div>
                    </div>

                    {/* Gợi ý */}
                    <div style={{ background: '#F9FAFB', padding: 24, borderRadius: 16, border: '1px solid #E5E7EB' }}>
                        <h3 style={{ margin: '0 0 16px', color: '#1F2937', display: 'flex', alignItems: 'center', gap: 8, fontSize: '18px' }}>
                            💡 Gợi ý chi tiết từ AI
                        </h3>
                        <ul style={{ paddingLeft: 20, margin: 0, color: '#4B5563', lineHeight: 1.6 }}>
                            {result.suggestions?.map((s, i) => <li key={i} style={{ marginBottom: 12 }}>{s}</li>)}
                        </ul>
                    </div>

                    {/* Bio Rewrite Suggestion */}
                    {result.rewrittenBio && (
                        <div style={{ marginTop: 30, background: 'linear-gradient(to right, #EFF6FF, #F5F3FF)', padding: 24, borderRadius: 16, border: '1px dashed #6366F1' }}>
                            <h3 style={{ margin: '0 0 12px', color: '#4F46E5', fontSize: '16px' }}>✨ Gợi ý viết lại Bio chuyên nghiệp:</h3>
                            <p style={{ fontStyle: 'italic', color: '#374151', margin: 0 }}>"{result.rewrittenBio}"</p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}